// French strings of the suggestions panel (registered at module load; see docs/UI-CONTRACT.md §7).
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  'sug.eyebrow': 'BLOC-NOTES DE L’ÉQUIPE',
  'sug.subtitle': 'Proposez une amélioration de l’application : l’administrateur l’approuve, puis elle est codée et publiée. Suivez ici où en est chacune.',
  'sug.loading': 'Chargement…',
  'sug.retry': 'Réessayer',
  'sug.unavailable': 'Les suggestions ne sont pas encore disponibles sur ce serveur.',

  // Composer
  'sug.compose.title': 'Proposer une amélioration',
  'sug.form.title': 'Titre',
  'sug.form.titlePlaceholder': 'En une phrase : ce qui manque ou ce qui gêne',
  'sug.form.text': 'Description',
  'sug.form.textPlaceholder': 'L’écran concerné, ce que vous faites aujourd’hui, ce que vous aimeriez à la place, un exemple…',
  'sug.form.textHint': 'Plus c’est précis, plus c’est rapide à coder.',
  'sug.form.shortcut': 'Ctrl (⌘) + Entrée pour envoyer',
  'sug.submit': 'PROPOSER',
  'sug.created': 'Suggestion envoyée. L’administrateur va l’examiner.',
  'sug.createdAdmin': 'Suggestion ajoutée : approuvez-la quand elle est prête.',
  'sug.error.titleRequired': 'Donnez un titre à votre suggestion.',
  'sug.error.titleTooLong': 'Le titre fait au plus 120 caractères.',
  'sug.error.textRequired': 'Décrivez votre suggestion.',
  'sug.error.textTooLong': 'La description fait au plus 10 000 caractères.',
  'sug.error.fix': 'Corrigez les champs signalés.',

  // Filters and list
  'sug.filtersLabel': 'Filtrer par statut',
  'sug.filter.all': 'Toutes',
  'sug.filter.proposed': 'Proposées',
  'sug.filter.approved': 'Approuvées',
  'sug.filter.in_progress': 'En cours',
  'sug.filter.done': 'Réalisées',
  'sug.filter.rejected': 'Refusées',
  'sug.search': 'Rechercher…',
  'sug.searchLabel': 'Rechercher dans les suggestions',
  'sug.listLabel': 'Suggestions',
  'sug.status.proposed': 'PROPOSÉE',
  'sug.status.approved': 'APPROUVÉE',
  'sug.status.in_progress': 'EN COURS',
  'sug.status.done': 'RÉALISÉE',
  'sug.status.rejected': 'REFUSÉE',
  'sug.mine': 'Vous',
  'sug.unknownAuthor': 'Ancien membre',
  'sug.showMore': 'Afficher tout ({n} caractères)',
  'sug.showLess': 'Réduire',
  'sug.review.approved': 'Approuvée par {name}',
  'sug.review.rejected': 'Refusée par {name}',
  'sug.work.in_progress': 'En cours',
  'sug.work.done': 'Réalisée',
  'sug.work.approved': 'Remise à approuvée',
  'sug.work.viaMcp': 'via Claude',
  'sug.work.commitTitle': 'Commit {commit}',
  'sug.work.version': 'Version {version}',
  'sug.memberHint.proposed': 'En attente de la décision de l’administrateur.',
  'sug.memberHint.approved': 'Approuvée : elle sera codée, puis publiée.',
  'sug.memberHint.done': 'Réalisée : disponible dans l’application une fois la version publiée.',

  // Empty states
  'sug.empty.memberTitle': 'Proposez votre première amélioration',
  'sug.empty.memberText': 'Un bouton qui manque, un écran peu clair, une idée d’automatisation : décrivez-la ci-dessus. L’administrateur la lit et décide ; vous suivez ensuite son avancement ici.',
  'sug.empty.adminTitle': 'Aucune suggestion pour le moment',
  'sug.empty.adminText': 'Les propositions de l’équipe arrivent ici. Approuvez celles à réaliser : Claude Code les lit depuis le connecteur de l’administrateur, les code et indique leur avancement.',
  'sug.empty.search': 'Aucune suggestion ne correspond à cette recherche.',
  'sug.empty.status.proposed': 'Aucune suggestion en attente de décision.',
  'sug.empty.status.approved': 'Aucune suggestion approuvée en attente de réalisation.',
  'sug.empty.status.in_progress': 'Aucune suggestion en cours de réalisation.',
  'sug.empty.status.done': 'Aucune suggestion réalisée pour le moment.',
  'sug.empty.status.rejected': 'Aucune suggestion refusée.',
  'sug.empty.showAll': 'Voir toutes les suggestions',

  // Admin actions
  'sug.decisionLabel': 'Décision',
  'sug.followLabel': 'Suivi',
  'sug.action.approve': 'APPROUVER',
  'sug.action.reject': 'REFUSER',
  'sug.action.start': 'Marquer en cours',
  'sug.action.finish': 'Marquer réalisée',
  'sug.action.reopen': 'Remettre à approuvée',
  'sug.prompt.approveTitle': 'Approuver la suggestion',
  'sug.prompt.rejectTitle': 'Refuser la suggestion',
  'sug.prompt.comment': 'Commentaire pour l’auteur',
  'sug.prompt.approveHint': 'Facultatif : une précision sur ce qui sera fait.',
  'sug.prompt.rejectHint': 'Facultatif, mais utile : expliquez pourquoi.',
  'sug.prompt.startTitle': 'Marquer en cours',
  'sug.prompt.finishTitle': 'Marquer réalisée',
  'sug.prompt.reopenTitle': 'Remettre à approuvée',
  'sug.prompt.note': 'Note',
  'sug.prompt.startHint': 'Facultatif : qui s’en occupe, ce qui est prévu.',
  'sug.prompt.finishHint': 'Facultatif : ce qui a été fait, la version publiée.',
  'sug.prompt.reopenHint': 'Facultatif : pourquoi le travail s’arrête (bloqué, abandonné…).',
  'sug.done.approve': 'Suggestion approuvée.',
  'sug.done.reject': 'Suggestion refusée.',
  'sug.done.start': 'Suggestion marquée en cours.',
  'sug.done.finish': 'Suggestion marquée réalisée.',
  'sug.done.reopen': 'Suggestion remise à approuvée.',

  // Row menu, edit and delete
  'sug.more': 'Plus d’actions',
  'sug.edit': 'Modifier',
  'sug.delete': 'Supprimer',
  'sug.editTitle': 'Modifier la suggestion',
  'sug.save': 'ENREGISTRER',
  'sug.saved': 'Suggestion modifiée.',
  'sug.deleteTitle': 'Supprimer la suggestion ?',
  'sug.deleteText': '« {title} » sera supprimée définitivement.',
  'sug.deleted': 'Suggestion supprimée.',
});
